import { Action } from 'redux';
import { SessionAssignmentError, SessionBusinessArea, ServiceSessionDay } from 'model/ServiceSession';

export const SERVICE_SESSIONS_RESET_ACTION_TYPE = 'serviceSessions/reset';
export const SERVICE_SESSIONS_FETCH_START_ACTION_TYPE = 'serviceSessions/fetch_start';
export const SERVICE_SESSIONS_FETCH_SUCCESS_ACTION_TYPE = 'serviceSessions/fetch_success';
export const SERVICE_SESSIONS_SAVE_START_ACTION_TYPE = 'serviceSessions/save_start';
export const SERVICE_SESSIONS_SAVE_SUCCESS_ACTION_TYPE = 'serviceSessions/save_success';
export const SERVICE_SESSIONS_ERROR_ACTION_TYPE = 'serviceSessions/error';
export const SERVICE_SESSIONS_CLEAR_WARNINGS_ACTION_TYPE = 'serviceSessions/clear_warnings';

type ServiceSessionsResetAction = Action<typeof SERVICE_SESSIONS_RESET_ACTION_TYPE>;

interface ServiceSessionsFetchStartAction extends Action<typeof SERVICE_SESSIONS_FETCH_START_ACTION_TYPE> {
    payload: {
        businessArea: SessionBusinessArea;
        startDate: string;
    };
}

interface ServiceSessionsFetchSuccessAction extends Action<typeof SERVICE_SESSIONS_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        startDate: string;
        endDate: string;
        days: Array<ServiceSessionDay>;
    };
}

type ServiceSessionsSaveStartAction = Action<typeof SERVICE_SESSIONS_SAVE_START_ACTION_TYPE>;

interface ServiceSessionsSaveSuccessAction extends Action<typeof SERVICE_SESSIONS_SAVE_SUCCESS_ACTION_TYPE> {
    payload: {
        warnings: Array<string>;
    };
}

interface ServiceSessionsErrorAction extends Action<typeof SERVICE_SESSIONS_ERROR_ACTION_TYPE> {
    payload: {
        error?: string;
        assignmentErrors: Array<SessionAssignmentError>;
    };
}

type ServiceSessionsClearWarningsAction = Action<typeof SERVICE_SESSIONS_CLEAR_WARNINGS_ACTION_TYPE>;

export type ServiceSessionsAction =
    | ServiceSessionsResetAction
    | ServiceSessionsFetchStartAction
    | ServiceSessionsFetchSuccessAction
    | ServiceSessionsSaveStartAction
    | ServiceSessionsSaveSuccessAction
    | ServiceSessionsErrorAction
    | ServiceSessionsClearWarningsAction;
